export default __webpack_public_path__ + "static/media/empty-data-7.6fd13b9a.svg";